import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { useFloatingSelect } from '../../../../hooks'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import { FloatingSelectDropdown } from '../../../Floating'

import * as styles from './PdfViewerToolbarMenu.module.css'

function PdfViewerToolbarMenu({
  afterIconProps,
  beforeIconProps,
  buttonClassName,
  qaName,
  sections,
  text,
  tooltip,
}) {
  const { t } = useTranslation()

  const { context, floatingStyles, getFloatingProps, isOpen, refs, setOpen } =
    useFloatingSelect({ placement: FLOATING_ELEMENT_PLACEMENT.bottomStart })

  const { setReference } = refs

  function handleToggle() {
    setOpen(previousValue => !previousValue)
  }

  function getHandleSelect(option) {
    return () => {
      setOpen(false)

      option.onSelect(option.value)
    }
  }

  return (
    <>
      <div ref={setReference}>
        <Button.Flat
          isGrey
          afterIconProps={afterIconProps}
          beforeIconProps={beforeIconProps}
          className={buttonClassName}
          height={BUTTON_HEIGHT_32}
          isActive={isOpen}
          qaName={qaName}
          text={text}
          tooltip={tooltip}
          onClick={handleToggle}
        />
      </div>
      <FloatingSelectDropdown
        context={context}
        floatingStyles={floatingStyles}
        getFloatingProps={getFloatingProps}
        isOpen={isOpen}
        refs={refs}
      >
        <div className={styles.menu}>
          {sections.map(section => (
            <div className={styles.section} key={section.id}>
              {section.titleKey ? (
                <span className={styles.sectionTitle}>
                  {t(section.titleKey)}
                </span>
              ) : null}
              {section.options.map(option => (
                <Button.Flat
                  isGrey
                  className={classNames(styles.option, {
                    [styles.selected]: option.isSelected,
                  })}
                  height={BUTTON_HEIGHT_32}
                  key={option.titleKey ?? option.value}
                  qaName={option.qaName}
                  text={option.title ?? t(option.titleKey)}
                  onClick={getHandleSelect(option)}
                />
              ))}
            </div>
          ))}
        </div>
      </FloatingSelectDropdown>
    </>
  )
}

export default PdfViewerToolbarMenu
